




































































































































































































































































































































import mixin from './mixin'

export default mixin.extend({
  name: 'TableDatalogEditor',
  components: {},
  data() {
    return {
      tagUid: '',
      forms: [{ title: 'Text', name: 'label', attribute: 'labelStyle' }],
    }
  },
})
